import { metadata } from "../../seo/seo";
export function getPageNameByUrl(pathname) {
  // const hash = location.hash ? location.hash.replaceAll('%20', ' ') : '';
  // if (!!hash) {
  //   const n = hash.lastIndexOf('/');
  //   const subPageName = hash.substring(n + 1);
  //   return capitalizeFirstLetter(subPageName.replaceAll('-', ' '));
  // }

  if (!!pathname) {
    const n = pathname.lastIndexOf('/');
    const mainPageName = pathname.substring(n + 1);
    //TODO: need to get rid of it
    if (mainPageName === 'ios') {
      return 'iOS';
    }
    if (mainPageName === 'react-native') {
      return 'React Native';
    }
    if (mainPageName === 'kyc') {
      return 'KYC';
    }
    if (mainPageName === 'bnpl') {
      return 'BNPL';
    }
    return capitalizeFirstLetter(mainPageName.replaceAll('-', ' '));

  }

  return 'subMenu';
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function getMetadata(page) {
  switch (page) {
    case '/docs/guides/getting-started':
      return metadata.guides.gettingStarted;
    case '/docs/guides/sandbox/authentication':
      return metadata.guides.sandbox.authentication;
    case '/docs/guides/sandbox/applications-management':
      return metadata.guides.sandbox.applicationsManagement;
    case '/docs/guides/sandbox/certificates-management':
      return metadata.guides.sandbox.certificatesManagement;
    case '/docs/guides/sandbox/browser-certificate-guide':
      return metadata.guides.sandbox.browserCertificateGuide;
    case '/docs/guides/sandbox/postman-certificate-guide':
      return metadata.guides.sandbox.postmanCertificateGuide;
    case '/docs/guides/deployments':
      return metadata.guides.deployments;
    case '/docs/guides/webhooks':
      return metadata.guides.webhooks;
    case '/docs/apis/identity':
      return metadata.apis.identity;
    case '/docs/apis/transfers':
      return metadata.apis.transfers;
    case '/docs/apis/kyc':
      return metadata.apis.kyc;
    case '/docs/apis/accounts':
      return metadata.apis.accounts;
    case '/docs/apis/loans':
      return metadata.apis.loans;
    case '/docs/apis/cards':
      return metadata.apis.cards;
    case '/docs/apis/bnpl':
      return metadata.apis.bnpl;
    case '/docs/apis/disputes':
      return metadata.apis.disputes;
    case '/docs/apis/data':
      return metadata.apis.data;
    case '/docs/apis/events':
      return metadata.apis.events;
    case '/docs/apis/remittance':
      return metadata.apis.remittance;
    case '/docs/apis/cliq':
      return metadata.apis.cliq;
    case '/docs/apis/files':
      return metadata.apis.files;
    case '/docs/apis/simulation':
      return metadata.apis.simulation;
    case '/docs/sdks/kyc':
      return metadata.sdks.kyc;
    default:
      return {};
  }
}
